// useGoogleAuth.js
import { useGoogleLogin } from "@react-oauth/google";
import { useState } from "react";
import { enrollUserWithGoogle, loginUserWithGoogle, fetchGoogleUserData } from "@/services/Auth/googleAuthService";
import Swal from "sweetalert2";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

const handleError = (errorMessage) => {
  Swal.fire({
    title: "Error",
    text: errorMessage,
    icon: "error",
    confirmButtonText: "Continuar",
    confirmButtonColor: "var(--navy-blue)",
  });
};

const handleSuccess = (title, message) => {
  Swal.fire({
    title: title,
    text: message,
    icon: "success",
    confirmButtonText: "Continuar",
    confirmButtonColor: "var(--navy-blue)",
  });
};

export const useGoogleAuth = (userType) => {
  const [user, setUser] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false); // Estado para mostrar el loader
  const navigate = useNavigate();

  const login = useGoogleLogin({
    onSuccess: async (codeResponse) => {
      console.log("Google Sign-In Successful:", codeResponse);
      setLoading(true); // Activamos el estado de carga

      Swal.fire({
        title: "Iniciando sesión...",
        text: "Por favor espera mientras te autenticamos",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        const userData = await fetchGoogleUserData(codeResponse.access_token);
        console.log("User Data:", userData);

        const response = await loginUserWithGoogle(codeResponse.access_token);
        setUser(response);
        console.log("Server Response:", response);

        if (response.error) {
          handleError(response.error === "Email already in use!" ? "Este correo electrónico ya está en uso. Por favor, usa otro." : response.error);
          setLoading(false);
          return;
        }

        handleSuccess("¡Bienvenido!", `Has iniciado sesión como ${response.account_data.username}`);
        Cookies.set("token", response.token, { expires: 1 });
        Cookies.set("refreshToken", response.rToken, { expires: 1 });
        Cookies.set("accessToken", codeResponse.access_token, { expires: 1 });
        Cookies.set("userData", JSON.stringify(response.user_data), { expires: 1 });
        Cookies.set("accountData", JSON.stringify(response.account_data), { expires: 1 });

        setTimeout(() => {
          Swal.close(); // Cierra el loader antes de redirigir
          switch (response.account_data.user_type) {
            case "Client":
              navigate("/dashboard/client");
              break;
            case "Lawyer":
            case "abogado":
              navigate("/dashboard/lawyer");
              break;
            case "admin":
              navigate("/dashboard/admin");
              break;
            default:
              navigate("/dashboard");
              console.log("default");
              break;
          }
        }, 1500); // Pequeño retraso para mejor UX

      } catch (error) {
        console.error("Error en el inicio de sesión:", error);
        setError("Hubo un problema al iniciar sesión");
        handleError("Hubo un problema al iniciar sesión. Inténtalo nuevamente.");
        setLoading(false);
        Swal.close();
      }
    },
    onError: (error) => {
      console.log("Google Sign-In Failed:", error);
      handleError("El inicio de sesión con Google falló");
    },
  });


  const register = useGoogleLogin({
    onSuccess: async (codeResponse) => {
      console.log("Google Sign-In Successful:", codeResponse);

      try {
        const userData = await fetchGoogleUserData(codeResponse.access_token);
        setUser(userData);
        console.log("User Data:", userData);

        const response = await enrollUserWithGoogle(codeResponse.access_token, userType);
        console.log("Server Response:", response);

        if (response.msg === "UserAccount by Google created" || response.error === "Email already in use!") {
          handleError("Este correo electrónico ya está en uso. Por favor, usa otro.");
          return;
        }

        if (!response.ok) {
          handleError(response);
          return;
        }

        handleSuccess("Éxito", "Cuenta creada correctamente");

      } catch (error) {
        console.error("Error en el registro:", error);
      
        // Verifica si el error es un objeto con un mensaje
        if (error.message) {
          if (error.message.includes("Email already in use!")) {
            handleError("Este correo electrónico ya está en uso. Por favor, usa otro.");
          } else {
            handleError("Hubo un problema al crear la cuenta. Inténtalo nuevamente.");
          }
        } else {
          handleError("Error desconocido. Intenta nuevamente.");
        }
      }
    },
    onError: () => {
      console.log("Error en el registro");
    },
  });

  return { login, register, user, error };
};
